@let isSm = viewportSelectors.isSm | select;
<div class="flex flex-col items-center">
  @if (!forLookupContext && isSm) {
    <img ngSrc="/assets/registration/create-account-sm.png" priority width="300" height="200" alt=""
         class="w-[18.75rem] h-[12.5rem] mb-6"/>
  }
  <mat-card class="max-w-[25rem]">
    <mat-card-content class="flex flex-col gap-y-3">
      @if (forLookupContext) {
        <div class="text-headline-large">Enter Your Email</div>
        <div class="text-body-large mb-8">Please provide your email address. This will be used as your username.</div>
      } @else {
        <div class="text-headline-large">Create Account</div>
        <div class="text-body-large mb-8">Please provide your email address. An email address is required to use many of
          our digital resources, such as e-books.
          If you do not wish to provide an email address, you can apply for a physical card in person at your local
          branch.
        </div>
      }

      <mx-input-form-field fieldName="email" [formGroup]="emailForm"/>
      @if (emailFieldControl.hasError('patronEmailUnavailable')) {
        <mat-error>
          An account with this email already exists. Log in <a pxNamedRouterLink="LOGIN">here</a>.
        </mat-error>
      }

      <mx-filled-button label="Submit" [enabled]="emailForm.valid" (click)="onClickNext()"/>
      @if (!forLookupContext) {
        <div>Already have an account? <a pxNamedRouterLink="INDEX">Login here</a></div>
      }
    </mat-card-content>
  </mat-card>
</div>
<div class="max-w-[50%] overflow-hidden ml-4">
  @let imageCssClasses = 'max-w-[20rem] lg:max-w-[29.5rem]';
  @if (!isSm) {
    @if (forLookupContext) {
      <img ngSrc="/assets/registration/verify-email.png" priority width="472" height="540" alt=""
           [class]="imageCssClasses"/>
    } @else {
      <img ngSrc="/assets/registration/create-account.png" priority width="472" height="480" alt=""
           [class]="imageCssClasses"/>
    }
  }
</div>
